import { useMemo } from 'react';
import useTeamMemberStore from '@/stores/TeamMemberStore';
import { Link as LinkIcon } from 'lucide-react';
import { useShallow } from 'zustand/react/shallow';

import { Button } from '@/components/ui/button';

const PersonalLinkButton = ({
  setMessage,
  textareaRef,
  channel,
  contactUsername,
  ownerId,
}) => {
  const { agents } = useTeamMemberStore(
    useShallow((state) => ({
      agents: state.agents,
    }))
  );

  // Get contact owner's calendar URL from agents list
  const ownerAgent = useMemo(() => {
    if (!ownerId || !agents) return null;
    return agents.find((agent) => agent._id === ownerId);
  }, [ownerId, agents]);

  const ownerCalendarUrl = ownerAgent?.calendar_url;

  // Check if personal link button should be shown
  const showPersonalLink =
    channel === 'instagram' && ownerCalendarUrl && contactUsername;

  const handlePersonalLinkClick = () => {
    if (!ownerCalendarUrl || !contactUsername) return;

    // Append IG parameter to the URL
    let linkWithParam;
    try {
      // Use the URL as-is and append IG parameter
      const url = new URL(ownerCalendarUrl);
      url.searchParams.set('IG', contactUsername);
      linkWithParam = url.toString();
    } catch (error) {
      // If URL parsing fails, just append as query parameter
      const separator = ownerCalendarUrl.includes('?') ? '&' : '?';
      linkWithParam = `${ownerCalendarUrl}${separator}IG=${contactUsername}`;
    }

    // Replace the message content with the link
    setMessage(linkWithParam);

    // Focus the textarea and move cursor to end
    setTimeout(() => {
      if (textareaRef.current) {
        textareaRef.current.focus();
        const len = linkWithParam.length;
        textareaRef.current.setSelectionRange(len, len);
      }
    }, 0);
  };

  if (!showPersonalLink) {
    return null;
  }

  return (
    <Button
      size='xs'
      variant='ghost'
      onClick={handlePersonalLinkClick}
      title='Insert personal link'
    >
      <LinkIcon className='h-5 w-5' />
    </Button>
  );
};

export default PersonalLinkButton;
